import React from "react";
import { useSEO } from "../hooks/useSEO";

function Section({ title, children }) {
  return (
    <div style={{ borderTop: "1px solid #1c1c1c", paddingTop: 48, paddingBottom: 48 }}>
      <h2
        className="font-serif mb-8"
        style={{ fontSize: "clamp(24px, 2.5vw, 36px)", color: "#F8F6F0", lineHeight: 1.1 }}
      >
        {title}
      </h2>
      <div style={{ color: "rgba(248,246,240,0.72)", fontSize: 16, lineHeight: 1.85 }}>
        {children}
      </div>
    </div>
  );
}

export default function MentionsLegales() {
  useSEO("Mentions légales", "Mentions légales, politique de confidentialité et informations juridiques du Stand d'Or.");

  return (
    <div className="pt-[140px] pb-40 max-w-[900px] mx-auto px-6 lg:px-12" data-testid="mentions-legales-page">
      <p className="label mb-8" style={{ color: "#C9A961" }}>Informations légales</p>
      <h1
        className="font-serif mb-4"
        style={{ fontSize: "clamp(48px, 8vw, 110px)", lineHeight: 0.92, letterSpacing: "-0.03em", color: "#F8F6F0" }}
      >
        Mentions légales.
      </h1>
      <p className="label mb-16" style={{ color: "#A1A1AA" }}>Mise à jour — avril 2026</p>

      <Section title="I. Éditeur du site">
        <p>Le site <strong style={{ color: "#F8F6F0" }}>lestanddor.com</strong> est édité par :</p>
        <p className="mt-4">
          <strong style={{ color: "#F8F6F0" }}>Le Stand d'Or</strong><br />
          Responsable de publication : Alisha<br />
          Contact : <a href="mailto:contact@lestanddor.com" style={{ color: "#C9A961", borderBottom: "1px solid rgba(201,169,97,0.4)" }}>contact@lestanddor.com</a>
        </p>
      </Section>

      <Section title="II. Hébergement">
        <p>
          Le site est hébergé par :<br />
          <strong style={{ color: "#F8F6F0" }}>Vercel Inc.</strong><br />
          440 N Barranca Ave #4133, Covina, CA 91723, États-Unis<br />
          <a href="https://vercel.com" target="_blank" rel="noopener noreferrer" style={{ color: "#C9A961" }}>vercel.com</a>
        </p>
        <p className="mt-6">
          La base de données est hébergée par :<br />
          <strong style={{ color: "#F8F6F0" }}>Supabase Inc.</strong><br />
          <a href="https://supabase.com" target="_blank" rel="noopener noreferrer" style={{ color: "#C9A961" }}>supabase.com</a>
        </p>
      </Section>

      <Section title="III. Propriété intellectuelle">
        <p>
          L'ensemble des contenus présents sur ce site — textes, visuels, logotype, typographie, mise en page — est
          la propriété exclusive du Stand d'Or, sauf mention contraire explicite.
        </p>
        <p className="mt-4">
          Toute reproduction, représentation, modification ou exploitation, totale ou partielle, de ces contenus,
          par quelque procédé que ce soit, sans l'autorisation préalable écrite du Stand d'Or, est strictement
          interdite et constituerait une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de
          la propriété intellectuelle.
        </p>
        <p className="mt-4">
          Les photographies de portraits sont soumises aux droits de leurs auteurs respectifs. Les crédits sont
          mentionnés au cas par cas.
        </p>
      </Section>

      <Section title="IV. Données personnelles (RGPD)">
        <p>
          Le Stand d'Or collecte des données personnelles dans les cas suivants :
        </p>
        <ul className="mt-4 space-y-3" style={{ paddingLeft: 20 }}>
          <li><strong style={{ color: "#F8F6F0" }}>Newsletter :</strong> adresse e-mail, utilisée uniquement pour l'envoi de communications officielles du Stand d'Or.</li>
          <li><strong style={{ color: "#F8F6F0" }}>Vote Prix du Public :</strong> nom (optionnel), adresse e-mail, numéro de téléphone, utilisés pour valider l'unicité du vote par catégorie.</li>
          <li><strong style={{ color: "#F8F6F0" }}>Formulaire partenariat :</strong> coordonnées professionnelles, utilisées uniquement pour traiter la demande.</li>
        </ul>
        <p className="mt-6">
          Conformément au Règlement (UE) 2016/679 (RGPD), vous disposez d'un droit d'accès, de rectification,
          d'opposition et de suppression de vos données. Pour exercer ces droits, contactez-nous à l'adresse :
          {" "}<a href="mailto:contact@lestanddor.com" style={{ color: "#C9A961", borderBottom: "1px solid rgba(201,169,97,0.4)" }}>contact@lestanddor.com</a>.
        </p>
        <p className="mt-4">
          Les données collectées ne sont jamais cédées, vendues ou louées à des tiers. Elles sont conservées
          pour la durée strictement nécessaire à la finalité pour laquelle elles ont été collectées.
        </p>
      </Section>

      <Section title="V. Newsletter">
        <p>
          L'inscription à la lettre officielle du Stand d'Or est basée sur le consentement explicite (opt-in).
          Chaque e-mail contient un lien de désabonnement en un clic. Vous pouvez également demander la
          suppression de votre adresse à tout moment par e-mail.
        </p>
        <p className="mt-4">
          Les envois sont réalisés via <strong style={{ color: "#F8F6F0" }}>Resend</strong> (infrastructure d'envoi d'e-mails transactionnels).
        </p>
      </Section>

      <Section title="VI. Cookies">
        <p>
          Ce site n'utilise pas de cookies publicitaires ou de tracking tiers. Aucune donnée de navigation
          n'est transmise à des régies publicitaires.
        </p>
        <p className="mt-4">
          Des cookies techniques strictement nécessaires au fonctionnement du site (session d'authentification
          admin) peuvent être déposés. Ils ne nécessitent pas de consentement au sens de la directive ePrivacy.
        </p>
      </Section>

      <Section title="VII. Liens hypertextes">
        <p>
          Le Stand d'Or ne peut être tenu responsable du contenu des sites tiers vers lesquels des liens sont
          proposés. La création de liens hypertextes vers ce site est autorisée sans accord préalable, à condition
          que la page de destination soit affichée dans sa propre fenêtre et que le lien ne soit pas utilisé à des
          fins commerciales ou publicitaires sans autorisation.
        </p>
      </Section>

      <div style={{ borderTop: "1px solid #1c1c1c", paddingTop: 32, marginTop: 16 }}>
        <p className="label" style={{ color: "rgba(248,246,240,0.3)", letterSpacing: "0.1em" }}>
          Le Stand d'Or — Paris, MMXXVI
        </p>
      </div>
    </div>
  );
}
